import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=3a72d312&scoped=true&"
import script from "./SocialLogin.vue?vue&type=script&lang=ts&"
export * from "./SocialLogin.vue?vue&type=script&lang=ts&"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=3a72d312&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a72d312",
  null
  
)

export default component.exports